import BaseRequestItemPermissionsModal from '../shared/BaseRequestItemPermissionsModal'

const QuarterbackRequestItemPermissionsModal = props => (
  <BaseRequestItemPermissionsModal
    {...props}
    showDefaultSettings={false}
  />
)

export default QuarterbackRequestItemPermissionsModal
